module.exports = __webpack_public_path__ + "img/incomeBlue.528d6006.png";